import {
    Mesh,
    NodeMaterial,
    Scene,
    ShadowGenerator,
    TransformNode} from "@babylonjs/core";
import { InputBlock } from "@babylonjs/core/Materials/Node/Blocks/Input/inputBlock";

export class Fire extends TransformNode {
    private mesh: Mesh;
    private material?: NodeMaterial;
    private shadowGenerator: ShadowGenerator;

    constructor (scene: Scene) {
        super("fire", scene);
        
        this.mesh = scene.getMeshByName("Fire") as Mesh;
        this.material = scene.getMaterialByName("fire_base") as NodeMaterial;
        this.mesh.material = this.material;
    }

    public enableGlowMask(): void {
        this.setGlowMaskValue(1.0);
    }

    public disableGlowMask(): void {
        this.setGlowMaskValue(0.0);
    }

    private setGlowMaskValue(value: number){
        const glowMask = this.material?.getBlockByName("glowMask");
        if(glowMask != null && glowMask instanceof InputBlock){
            glowMask.value = value;
        }
    }

    public getMesh(): Mesh {
        return this.mesh;
    }

    public getShadowGenerator(): ShadowGenerator {
        return this.shadowGenerator;
    }
}